import React from 'react';
import { motion } from 'framer-motion';
export function SlideTitle() {
  return <div className="h-full w-full bg-[#1A1A2E] text-white flex flex-col justify-between p-12 md:p-24 relative overflow-hidden" data-id="element-643">
      {/* CSL brand background with diagonal clip */}
      <div className="absolute inset-0 w-full h-full pointer-events-none opacity-40" style={{
      clipPath: 'polygon(0 0, 55% 0, 45% 100%, 0 100%)',
      background: 'linear-gradient(135deg, #E60012 0%, #C5000F 100%)'
    }} data-id="element-644" />

      {/* Background decoration - angular gradient */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#E60012]/20 to-transparent pointer-events-none" data-id="element-645" />

      {/* Diagonal accent line */}
      <div className="absolute top-0 left-[45%] w-1 h-full bg-gradient-to-b from-[#E60012] via-[#C5000F] to-[#1A1A2E] pointer-events-none opacity-60" style={{
      transform: 'skewX(-15deg)'
    }} data-id="element-646" />

      {/* Main Content */}
      <main className="flex-1 flex flex-col justify-center z-10 max-w-[55%]" data-id="element-647">
        <motion.h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-648">
          Snakker™ for <br data-id="element-649" />
          <span className="text-[#E60012]" data-id="element-650">Rare Disease Congresses</span>
        </motion.h1>

        <motion.div className="h-1 w-32 bg-gradient-to-r from-[#E60012] to-[#C5000F] mb-8" initial={{
        width: 0
      }} animate={{
        width: 128
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-651" />

        <motion.p className="text-2xl text-gray-300 font-light" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-652">
          The Conversion Funnel – From Awareness to Booth Engagement
        </motion.p>
      </main>

      {/* Footer Hint */}
      <motion.footer className="flex items-center gap-2 text-gray-400 text-sm z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-653">
        <span data-id="element-654">Press</span>
        <div className="px-2 py-1 border border-gray-600 rounded bg-white/5 font-mono text-xs" data-id="element-655">
          →
        </div>
        <span data-id="element-656">to begin</span>
      </motion.footer>
    </div>;
}